/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Button, DropDown, Input } from "../../../components";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { GetSportsForFacility } from "../../../utilities/api/sports/indext";
import { toast } from "react-toastify";
import { ModalForSlots } from "./ModalForSlots";
import {
  GetCourtsAvailableForAssociateBooking,
  GetSlotsForAssociateBooking,
} from "../../../utilities/api/courts";
import { format } from "date-fns";
import { GetAssociateBookingAmount } from "../../../utilities/api/associateBooking";
import { AllCourtsList } from "../../../redux/Slice/Courts/CourtsListSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook";
import { WEEK_DAYS, dayOrder } from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.associateBooking;

const AssociateBookingSelectSlot = (props: any) => {
  const {
    associateBookingData,
    setAssociateBookingData,
    setCurrentStep,
    setAmount,
  } = props;
  const { AllCourtsData, errorMessage } = useAppSelector((state) => state.courtsList);
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const [sportList, setSportList] = useState([]);
  const [ruleList, setRuleList] = useState({}) as any;
  const [slotsList, setSlotsList] = useState([]) as any;
  const [bookingDay, setBookingDay] = useState("");
  const [currentSlots, setCurrentSlots] = useState([]) as any;
  const [courtList, setCourtList] = useState([]) as any;
  const [optionCourts, setOptionCourts] = useState([]) as any;
  const [error, setError] = useState({
    sportId: "",
    startDate: "",
    endDate: "",
    slots: "",
  });
  const [buttonDisable, setButtonDisable] = useState(false);
  const [slot, setSlot] = useState([]) as any;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const GetSlots = async () => {
    let startDate = associateBookingData.startDate
      ? format(new Date(associateBookingData.startDate), "yyyy-MM-dd")
      : associateBookingData.startDate;

    let endDate = associateBookingData.endDate
      ? format(new Date(associateBookingData.endDate), "yyyy-MM-dd")
      : associateBookingData.endDate;

    const result = await GetSlotsForAssociateBooking(
      startDate,
      endDate,
      associateBookingData.facilityId,
      associateBookingData.sportId
    );
    if (result.statusCode === 200) {
      setSlotsList(result?.data?.timeSlots);
    }
  };

  const GetSport = async () => {
    const result = await GetSportsForFacility(associateBookingData.facilityId);
    if (result.statusCode == 200) {
      setSportList(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetCourts = async () => {

    let slots = currentSlots?.map((item: any) => ({
      startTime: item.startTime,
      endTime: item.endTime,
      sessionDay: bookingDay,
    }));
    let payload = {
      facilityId: Number(associateBookingData.facilityId),
      sportId: Number(associateBookingData.sportId),
      startDate: associateBookingData.startDate
        ? format(new Date(associateBookingData.startDate), "yyyy-MM-dd")
        : associateBookingData.startDate,
      endDate: associateBookingData.endDate
        ? format(new Date(associateBookingData.endDate), "yyyy-MM-dd")
        : associateBookingData.endDate,
      slots: slots,
    };
    if (currentSlots.length) {
      const result = await GetCourtsAvailableForAssociateBooking(payload);
      if (result.status === 200) {
        setCourtList(result.data.data.rows);
        !result.data.data.rows.length && toast.error(getMessage.court_isUnavailable);
      }
    }
  };

  useEffect(() => {
    associateBookingData.facilityId &&
      associateBookingData.sportId &&
      associateBookingData.startDate &&
      associateBookingData.endDate &&
      GetSlots();
  }, [
    associateBookingData.facilityId,
    associateBookingData.sportId,
    associateBookingData.startDate,
    associateBookingData.endDate,
  ]);

  useEffect(() => {
    dispatch(
      AllCourtsList({
        facilityId: associateBookingData.facilityId,
        sportId: associateBookingData.sportId,
      })
    );
  }, [associateBookingData.facilityId, associateBookingData.sportId]);

  useEffect(() => {
    GetSport();
  }, [associateBookingData.facilityId]);

  useEffect(() => {
    GetCourts();
  }, [currentSlots, bookingDay]);

  useEffect(() => {
    let courts = courtList?.map((item: any) => ({
      labelKey: item.id,
      value: item.name,
    }));
    setOptionCourts(courts);
  }, [courtList]);

  useEffect(() => {

    const sortedData = associateBookingData.selectedSlots.sort(
      (a: any, b: any) => {
        const dayComparison =
          dayOrder.indexOf(a.bookingDay) - dayOrder.indexOf(b.bookingDay);
        if (dayComparison !== 0) {
          return dayComparison;
        }
        return a.startTime.localeCompare(b.startTime);
      }
    );
    setAssociateBookingData({
      ...associateBookingData,
      selectedSlots: sortedData,
    });
  }, [associateBookingData.selectedSlots]);

  const handleSportId = (e: any) => {
    setAssociateBookingData({
      ...associateBookingData,
      sportId: e.target.value,
      selectedSlots: [],
    });
    setRuleList(sportList.filter((item: any) => item.id == e.target.value)[0]);
  };

  const handleChange = (value: any) => {
    let payloadSlot = currentSlots?.map((item: any) => ({
      ...item,
      courts: value.selectedKey,
    }));
    setCurrentSlots(payloadSlot);
  };

  const handleAdd = () => {
    setAssociateBookingData((prevData: any) => {
      const existingSlotIndex = prevData?.selectedSlots?.findIndex(
        (elem: any) => elem.bookingDay === bookingDay
      );
      if (existingSlotIndex === -1) {
        return {
          ...prevData,
          selectedSlots: [
            ...prevData?.selectedSlots,
            ...currentSlots.map((item: any) => ({
              ...item,
              bookingDay: bookingDay,
            })),
          ],
        };
      } else {
        const updatedSlots = prevData?.selectedSlots.map((elem: any) => {
          if (elem.bookingDay === bookingDay) {
            const matchingSlot = currentSlots.find(
              (item: any) => item.startTime === elem.startTime
            );
            let temp =
              matchingSlot !== undefined
                ? { ...matchingSlot, bookingDay: bookingDay }
                : elem;
            return temp;
          }
          return elem;
        });

        const newSlots = currentSlots.filter(
          (item: any) =>
            !prevData.selectedSlots.some(
              (elem: any) =>
                elem.bookingDay === bookingDay &&
                elem.startTime === item.startTime
            )
        );

        return {
          ...prevData,
          selectedSlots: [
            ...updatedSlots,
            ...newSlots?.map((item: any) => ({
              ...item,
              bookingDay: bookingDay,
            })),
          ],
        };
      }
    });
    setCurrentSlots([]);
    setOptionCourts([]);
    setBookingDay("");
    setSlot([]);
  };

  const handleGetAmount = async () => {
    setButtonDisable(true);
    let payload = {
      facilityId: Number(associateBookingData.facilityId),
      sportId: Number(associateBookingData.sportId),
      startDate: associateBookingData.startDate
        ? format(new Date(associateBookingData.startDate), "yyyy-MM-dd")
        : associateBookingData.startDate,
      endDate: associateBookingData.endDate
        ? format(new Date(associateBookingData.endDate), "yyyy-MM-dd")
        : associateBookingData.endDate,
      selectedSlots: associateBookingData.selectedSlots,

      isIgstTax: "false",
    };
    if (validate()) {
      const amount = await GetAssociateBookingAmount(payload);
      if (amount.status === 200) {
        setAmount(amount.data.data);
        setCurrentStep((_oldVal: number) => {
          if (_oldVal < 1) {
            return ++_oldVal;
          } else {
            return _oldVal;
          }
        });
      } else {
        toast.error(amount.response.data.message);
      }
    }
    setButtonDisable(false);
  };

  const validate = () => {
    if (
      !associateBookingData.sportId ||
      !associateBookingData.startDate ||
      !associateBookingData.endDate ||
      !associateBookingData.selectedSlots.length
    ) {
      setError({
        sportId: !associateBookingData.sportId ? getMessage.sport_isNotEmpty : "",
        startDate: !associateBookingData.startDate
          ? getMessage.startDate_isNotEmpty
          : "",
        endDate: !associateBookingData.endDate ? getMessage.endDate_isNotEmpty : "",
        slots:
          associateBookingData.selectedSlots.length === 0
            ? getMessage.slots_isNotEmpty
            : "",
      });
      return false;
    } else {
      return true;
    }
  };

  const handleSlotDelete = (index: number) => {
    let deletedSlot = associateBookingData?.selectedSlots.filter(
      (_: any, ind: number) => ind !== index
    );
    setAssociateBookingData({
      ...associateBookingData,
      selectedSlots: deletedSlot,
    });
  };

  const renderTooltip = (props: any) => (
    <Tooltip {...props}>
      {currentSlots?.map((item: any, index: number) =>
        currentSlots?.length - 1 !== index
          ? `${item.startTime} to ${item.endTime}, `
          : `${item.startTime} to ${item.endTime}`
      )}
    </Tooltip>
  );
  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">Associate Booking</Card.Title>
            </div>
            <Row>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="sport" className="form-label">
                    Select Sport <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    className="form-control"
                    id="sport"
                    name="sport"
                    disabled={associateBookingData?.facilityId <= 0}
                    value={associateBookingData.sportId}
                    onChange={(e: any) => handleSportId(e)}
                  >
                    <option hidden disabled value="">
                      Select Sport
                    </option>
                    {sportList?.map((item: any) => {
                      return (
                        <option key={item.id + "sport"} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </DropDown>
                  <span className="error-msg">{error?.sportId}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="startdate" className="form-label">
                    Start Date <small className="text-danger">*</small>
                  </label>
                  <DatePicker
                    id="startdate"
                    inputClass="form-control"
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    render={<InputIcon className="form-control" />}
                    minDate={new Date()}
                    editable={false}
                    value={new Date(associateBookingData?.startDate)}
                    onChange={(date: any) => {
                      setAssociateBookingData({
                        ...associateBookingData,
                        startDate: date?.toDate().toUTCString(),
                        selectedSlots: [],
                      });
                    }}
                  />
                  <span className="error-msg">{error?.startDate}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="end-date" className="form-label">
                    End Date <small className="text-danger">*</small>
                  </label>
                  <DatePicker
                    id="end-date"
                    inputClass="form-control"
                    format="DD/MM/YYYY"
                    containerClassName="custom-container"
                    render={<InputIcon className="form-control" />}
                    value={new Date(associateBookingData?.endDate)}
                    editable={false}
                    minDate={
                      associateBookingData.startDate
                        ? new Date(associateBookingData.startDate)
                        : new Date()
                    }
                    onChange={(date: any) => {
                      setAssociateBookingData({
                        ...associateBookingData,
                        endDate: date?.toDate().toUTCString(),
                        selectedSlots: [],
                      });
                    }}
                  />
                  <span className="error-msg">{error?.endDate}</span>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="day" className="form-label">
                    Select Day <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    className="form-control"
                    id="day"
                    name="day"
                    onChange={(e: any) => setBookingDay(e?.target?.value)}
                    value={bookingDay}
                  >
                    <option>Select Day</option>
                    {WEEK_DAYS.map((_day: any) => {
                      return <option key={_day}>{_day}</option>;
                    })}
                  </DropDown>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <label htmlFor="slot" className="form-label">
                    Select Slot <small className="text-danger">*</small>
                  </label>

                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <span>
                      <Input
                        value={currentSlots?.map(
                          (item: any) => `${item.startTime} to ${item.endTime}`
                        )}
                        type="text"
                        name="slot"
                        id="slot"
                        title=""
                        onClick={handleShow}
                        className="form-control"
                        disabled={
                          !associateBookingData.facilityId ||
                          !associateBookingData.sportId ||
                          !associateBookingData.startDate ||
                          !associateBookingData.endDate
                        }
                      />
                    </span>
                  </OverlayTrigger>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="courts" className="form-label">
                    Select Court <small className="text-danger">*</small>
                  </label>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={optionCourts || []}
                    isMultiSelect={true}
                    showTick={true}

                    showAction={true}
                    placeholder="Select Courts"
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col lg={1}>
                <div className="text-start mt-3">
                  <Button
                    disabled={
                      !bookingDay ||
                      currentSlots.length === 0 ||
                      currentSlots[0].courts?.length === 0 ||
                      optionCourts.length === 0
                    }
                    type="button"
                    bname="Add"
                    name="addslot"
                    id="addslot"
                    className="btn btn-primary rounded-1"
                    onClick={handleAdd}
                  ></Button>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="selectendtime"
                    className="d-block form-label mb-0"
                  >
                    Selected Slots
                  </label>
                  {associateBookingData?.selectedSlots?.map(
                    (item: any, index: number) => {
                      return (
                        <Card
                          className="bg-light bg-opacity-25 border-left-5 border-light mb-3"
                          key={index}
                        >
                          <Card.Body className="p-2">
                            <Row>
                              <Col lg={3}>
                                <div className="date-range fw-semibold">
                                  {item.bookingDay}
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="time-slot fw-semibold">
                                  {item.startTime} to {item.endTime}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="date-range fw-semibold">
                                  {item.courts?.map((elem: any, ind: any) =>
                                    ind !== item.courts?.length - 1
                                      ? `${AllCourtsData?.find(
                                        (_court: any) => _court.id == elem
                                      )?.name
                                      }, `
                                      : `${AllCourtsData?.find(
                                        (_court: any) => _court.id == elem
                                      )?.name
                                      }`
                                  )}
                                </div>
                              </Col>
                              <Col lg={2} className="text-end">
                                <Button
                                  onClick={() => handleSlotDelete(index)}
                                  type="button"
                                  bname="Delete"
                                  name="cancel-slot"
                                  id="Delete"
                                  className="btn btn-sm btn-outline-primary px-4 rounded-1"
                                ></Button>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      );
                    }
                  )}
                  <span className="error-msg">{error?.slots}</span>
                </div>
              </Col>
              <Col lg={12}>
                <Card className="mt-4">
                  <Card.Body className="p-3 ">
                    <Card.Title className="card-title h5 text-start mb-2">
                      Rules
                    </Card.Title>
                    <ol className="list-group list-group-flush list-group-numbered text-start">
                      {ruleList?.sportRules?.map((item: any) => {
                        return (
                          <li key={item.id} className="list-group-item">
                            {item.rule.subject}
                          </li>
                        );
                      })}
                    </ol>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="text-end mt-3">
                <Button
                  disabled={buttonDisable}
                  onClick={handleGetAmount}
                  type="submit"
                  bname="Continue"
                  name="continue"
                  id="continue"
                  className="btn btn-primary px-4 rounded-1"
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ModalForSlots
        show={show}
        handleClose={handleClose}
        slotsList={slotsList}
        setOptionCourts={setOptionCourts}
        setCurrentSlots={setCurrentSlots}
        setSlot={setSlot}
        slot={slot}
      />
    </>
  );
};
export { AssociateBookingSelectSlot };
